export const userActions = {
  initProgress,
  resetProgress,
  logout,
  consentSigned,
  updatePreSurveySelection,
  submitPreSurvey,
  updatePostSurveySelection,
  submitPostSurvey,
};

function initProgressSucceeded(stateObj) {
  return {
    type: "INIT_PROGRESS_SUCCEEDED",
    payload: {
      progress: stateObj,
    },
  };
}

function initProgress(progress) {
  return (dispatch) => {
    dispatch(initProgressSucceeded(progress));
  };
}

function resetProgressSucceeded() {
  return {
    type: "RESET",
  };
}

function resetProgress() {
  return (dispatch) => dispatch(resetProgressSucceeded());
}

function logoutSucceeded() {
  return {
    type: "LOGOUT",
  };
}

function logout(progress) {
  return (dispatch) => {
    dispatch(logoutSucceeded(progress));
  };
}

function consentSignedSucceeded() {
  return {
    type: "SIGNED_CONSENT_SUCCEEDED",
  };
}

function consentSigned() {
  return (dispatch) => {
    dispatch(consentSignedSucceeded());
  };
}

function updatePreSurveySelectionSucceeded(form) {
  return {
    type: "UPDATE_PRESURVEY_SELECTION_SUCCEEDED",
    payload: {
      form: form,
    },
  };
}

function updatePreSurveySelection(form) {
  return (dispatch) => {
    dispatch(updatePreSurveySelectionSucceeded(form));
  };
}

function submitPreSurveySucceeded() {
  return {
    type: "SUBMIT_PRESURVEY_SUCCEEDED",
  };
}

function submitPreSurvey() {
  return (dispatch) => {
    dispatch(submitPreSurveySucceeded());
  };
}

function updatePostSurveySelectionSucceeded(form) {
  return {
    type: "UPDATE_POSTSURVEY_SELECTION_SUCCEEDED",
    payload: {
      form: form,
    },
  };
}

function updatePostSurveySelection(form) {
  return (dispatch) => {
    dispatch(updatePostSurveySelectionSucceeded(form));
  };
}

function submitPostSurveySucceeded() {
  return {
    type: "SUBMIT_POSTSURVEY_SUCCEEDED",
  };
}

function submitPostSurvey() {
  return (dispatch) => {
    dispatch(submitPostSurveySucceeded());
  };
}
